/**
 * Catálogos de Producción → Ajustes.
 * Persistencia local (localStorage). Planificación / Shop / Solicitudes T-COAT leen desde aquí.
 */

export const PRODUCTION_CATALOG_STORAGE_KEY = 'sqmt_production_catalogs_v1';
export const PRODUCTION_CATALOGS_CHANGED_EVENT = 'sqmt-production-catalogs-changed';

const item = (id, code, label, description, sort_order, color_hex, extras = {}) => ({
  id,
  code,
  label,
  description,
  sort_order,
  color_hex,
  is_active: 'Sí',
  ...extras,
});

export const codeFromLabel = (label) =>
  String(label || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 40);

export const CATALOG_DEFINITIONS = [
  {
    key: 'product_request_status',
    group: 'requests',
    label: 'Estados solicitud T-COAT',
    description: 'Estados de solicitudes de producto. El color se usa en Planificación y Solicitudes.',
  },
  {
    key: 'product_request_origin',
    group: 'requests',
    label: 'Orígenes de solicitud',
    description: 'Orígenes al crear una solicitud de producto.',
  },
  {
    key: 'product_request_rejection_reason',
    group: 'requests',
    label: 'Motivos de rechazo',
    description: 'Motivos al rechazar o cancelar una solicitud desde Planificación.',
  },
  {
    key: 'product_request_item_progress',
    group: 'requests',
    label: 'Avance de ítems',
    description: 'Estados de avance por producto dentro de una solicitud aceptada.',
  },
  {
    key: 'batch_status',
    group: 'shop',
    label: 'Estados de lote / OP',
    description: 'Estados del ciclo de vida de lotes en Producción (shop).',
  },
  {
    key: 'formula_status',
    group: 'formulas',
    label: 'Estados de fórmula',
    description: 'Estados del catálogo de fórmulas.',
  },
];

export const CATALOG_GROUPS = [
  {
    key: 'requests',
    label: 'Solicitudes',
    description: 'Estados, orígenes y motivos de solicitudes T-COAT.',
  },
  {
    key: 'shop',
    label: 'Producción',
    description: 'Estados de lotes / órdenes de producción.',
  },
  {
    key: 'formulas',
    label: 'Fórmulas',
    description: 'Estados del catálogo de fórmulas.',
  },
];

export const DEFAULT_CATALOG_ITEMS = {
  product_request_status: [
    item(1, 'SOLICITADO', 'Solicitado', 'Solicitud creada, pendiente de planificación', 10, '#64748b'),
    item(2, 'PLANIFICADA', 'Planificada', 'Aceptada y planificada en producción', 20, '#0ea5e9'),
    item(3, 'EN_PROCESO', 'En Proceso', 'En fabricación / proceso', 30, '#d97706'),
    item(4, 'TERMINADA', 'Terminada', 'Fabricación terminada', 40, '#15803d'),
    item(5, 'ENTREGADA', 'Entregada', 'Entregada a comercial / logística', 50, '#0f766e'),
    item(6, 'RECHAZADA', 'Rechazada', 'Rechazada por producción', 60, '#dc2626'),
    item(7, 'EN_REPROGRAMACION', 'En Reprogramación', 'Pendiente de nueva fecha', 70, '#9333ea'),
    item(8, 'CANCELADA', 'Cancelada', 'Cancelada', 80, '#71717a'),
  ],
  product_request_origin: [
    item(1, 'COMERCIAL', 'Comercial', 'Generada desde Comercial', 10, '#2563eb'),
    item(2, 'BODEGA_PT', 'Bodega PT', 'Generada desde bodega de producto terminado', 20, '#0ea5e9'),
    item(3, 'STOCK_MINIMO', 'Stock mínimo', 'Reposición por stock mínimo', 30, '#f59e0b'),
    item(4, 'MUESTRA', 'Muestra', 'Solicitud de muestra', 40, '#8b5cf6'),
    item(5, 'REPOSICION', 'Reposición', 'Reposición general', 50, '#16a34a'),
  ],
  product_request_rejection_reason: [
    item(1, 'FALTA_MP', 'Falta de materia prima', 'No hay stock de materias primas', 10, '#dc2626'),
    item(2, 'FORMULA', 'Fórmula o color no disponible', 'Fórmula o color no está disponible', 20, '#ea580c'),
    item(3, 'CAPACIDAD', 'Capacidad de producción insuficiente', 'No hay capacidad en la planta', 30, '#c2410c'),
    item(4, 'FECHA', 'Fecha límite no factible', 'La fecha límite no es alcanzable', 40, '#b45309'),
    item(5, 'INFO', 'Información incompleta o incorrecta', 'Faltan datos para fabricar', 50, '#a16207'),
    item(6, 'DUPLICADA', 'Solicitud duplicada', 'Ya existe una solicitud equivalente', 60, '#78716c'),
    item(7, 'NO_FABRICABLE', 'Producto no fabricable', 'El producto no se puede fabricar', 70, '#9a3412'),
    item(8, 'OTRO', 'Otro', 'Otro motivo; detallar en observaciones', 90, '#57534e'),
  ],
  product_request_item_progress: [
    item(1, 'PLANIFICADO', 'Planificado', 'Ítem planificado, aún no en fabricación', 10, '#0ea5e9'),
    item(2, 'EN_FABRICACION', 'En Fabricación', 'Ítem en proceso de fabricación', 20, '#d97706'),
    item(3, 'TERMINADO', 'Terminado', 'Ítem terminado', 30, '#15803d'),
  ],
  batch_status: [
    item(1, 'BORRADOR', 'Borrador', 'Lote en borrador', 10, '#9ca3af'),
    item(2, 'PLANIFICADA', 'Planificada', 'OP planificada', 20, '#2563eb'),
    item(3, 'EMITIDA', 'Emitida', 'OP emitida a planta', 30, '#0ea5e9'),
    item(4, 'EN_PROCESO', 'En proceso', 'En fabricación', 40, '#d97706'),
    item(5, 'FABRICADO', 'Fabricado', 'Fabricado, pendiente de calidad', 50, '#7c3aed'),
    item(6, 'EN_CALIDAD', 'En calidad', 'En control de calidad', 60, '#c026d3'),
    item(7, 'REPROCESO', 'Reproceso', 'En reproceso', 70, '#c2410c'),
    item(8, 'TERMINADO', 'Terminado', 'Lote terminado', 80, '#15803d'),
    item(9, 'ANULADA', 'Anulada', 'OP anulada', 90, '#dc2626'),
  ],
  formula_status: [
    item(1, 'BORRADOR', 'Borrador', 'Fórmula en borrador', 10, '#64748b'),
    item(2, 'ACTIVA', 'Activa', 'Fórmula activa para producción', 20, '#16a34a'),
    item(3, 'OBSOLETA', 'Obsoleta', 'Fórmula fuera de uso', 30, '#9ca3af'),
  ],
};

export const loadProductionCatalogItemsFromStorage = () => {
  try {
    if (typeof window === 'undefined') return { ...DEFAULT_CATALOG_ITEMS };
    const raw = window.localStorage.getItem(PRODUCTION_CATALOG_STORAGE_KEY);
    if (!raw) return { ...DEFAULT_CATALOG_ITEMS };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return { ...DEFAULT_CATALOG_ITEMS };
    const merged = { ...DEFAULT_CATALOG_ITEMS };
    Object.keys(DEFAULT_CATALOG_ITEMS).forEach((key) => {
      if (Array.isArray(parsed[key]) && parsed[key].length) merged[key] = parsed[key];
    });
    return merged;
  } catch {
    return { ...DEFAULT_CATALOG_ITEMS };
  }
};

export const saveProductionCatalogItemsToStorage = (itemsByKey) => {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(PRODUCTION_CATALOG_STORAGE_KEY, JSON.stringify(itemsByKey));
    window.dispatchEvent(
      new CustomEvent(PRODUCTION_CATALOGS_CHANGED_EVENT, {
        detail: { keys: Object.keys(itemsByKey || {}) },
      })
    );
  } catch {
    // ignore quota / private mode
  }
};

const activeRows = (key, items) => {
  const catalog = items != null ? null : loadProductionCatalogItemsFromStorage();
  const source = Array.isArray(items)
    ? items
    : (catalog && catalog[key]) || DEFAULT_CATALOG_ITEMS[key] || [];
  return (Array.isArray(source) ? source : [])
    .filter((row) => String(row.is_active || 'Sí').toLowerCase() === 'sí')
    .slice()
    .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0));
};

const rowsToLabelOptions = (rows) =>
  rows
    .map((row) => ({
      value: String(row.label || row.code || '').trim(),
      label: String(row.label || row.code || '').trim(),
      code: row.code,
      color_hex: row.color_hex || '#2563eb',
      sort_order: Number(row.sort_order || 0),
    }))
    .filter((opt) => opt.value);

export const getActiveProductionCatalogRows = (key, items) => activeRows(key, items);

export const getActiveProductionCatalogOptions = (key, items) =>
  rowsToLabelOptions(activeRows(key, items));

export const getProductionCatalogColorMap = (key, items) => {
  const map = {};
  activeRows(key, items).forEach((row) => {
    const label = String(row.label || '').trim();
    if (!label) return;
    map[label] = row.color_hex || '#64748b';
  });
  return map;
};
